import { HeartPulse } from "lucide-react";

import type { HomePatient } from "@/api/adapters/home-dashboard";
import { EmptyMessage } from "@/components/feedback/EmptyMessage";

import { maskNameKeepLast } from "../utils";
import { RiskPill } from "@/components/ui/RiskPill";

interface Props {
	data: HomePatient[];
	t: (key: string, opts?: Record<string, unknown>) => string;
	navigate: (path: string) => void;
}

export function RDangerDetail({ data: patients, t, navigate }: Props) {
	if (!patients.length) {
		return <EmptyMessage msg={t("medical:home.sections.atRisk.empty")} />;
	}

	return (
		<div className="modal-pat-list">
			{patients.map((p) => (
				<div key={p.uid} className="modal-pat modal-pat--danger">
					<div className="modal-pat__main">
						<div className="modal-pat__head">
							<a
								href={`#/patients?selected=${p.uid}&tab=pro`}
								className="modal-pat__name"
								onClick={(e) => {
									e.preventDefault();
									navigate(`/patients?selected=${p.uid}&tab=pro`);
								}}
							>
								<strong>{maskNameKeepLast(p.name)}</strong>
								{p.mrn && <small>({p.mrn})</small>}
								{" · "}
								{p.primaryDxName}
								{/* SHCT-828 — the shared pill, tinted by the risk level like 환자 관리.
								    산출 불가 = riskLevel 'UNKNOWN' (BE-assigned) and is decided inside
								    the pill; hrAbnormal 등 다른 사유의 무점수 환자를 산출 불가로 오표기하지
								    않도록 riskScore==null 은 그 판정에 쓰지 않는다. */}
								<RiskPill riskScore={p.riskScore} riskLevel={p.riskLevel} t={t} />
								{p.hrAbnormal && (
									<span
										className="grade-chip grade-chip--hr"
										title={t("medical:home.sections.atRisk.hrTooltip")}
									>
										<HeartPulse size={12} style={{ marginRight: 2 }} />
										{p.restingHr != null
											? `${
													p.restingHr < 60
														? t("medical:home.sections.atRisk.hrBrady")
														: t("medical:home.sections.atRisk.hrTachy")
												} ${p.restingHr}bpm`
											: t("medical:home.sections.atRisk.hrFallback")}
									</span>
								)}
							</a>
						</div>
					</div>
					<div className="modal-pat__actions">
						<a
							href={`#/patients?selected=${p.uid}&tab=pro`}
							className="btn btn--xs btn--secondary"
							onClick={(e) => {
								e.preventDefault();
								navigate(`/patients?selected=${p.uid}&tab=pro`);
							}}
						>
							{t("medical:home.detail.goToPatient")}
						</a>
					</div>
				</div>
			))}
		</div>
	);
}
